import React from 'react';
import { useTranslation } from 'react-i18next';
import CreateApplication from 'Modules/lendFlow/routes/CreateApplication';
import { useGetNextStep } from 'Modules/lendFlow/hooks/useGetNextStep';
import { useGetPaymentInfo } from 'Core/hooks/platform/useGetPaymentInfo';
import Loader from 'Core/components/Loader';
import constants from 'Modules/lendFlow/config/constants';
import { errorPath } from 'Core/routes';
import useErrorStore, { setErrorActionSelector } from 'Core/stores/error';
import { useNavigate } from 'react-location';
import { createFinancingPath as allegroFinancingPath } from 'Modules/financing/routes';
import { createFinancingPath as patientfiFinancingPath } from 'Modules/patientfi/routes';

export default function FinancingRedirect() {
  const navigate = useNavigate();
  const setError = useErrorStore(setErrorActionSelector);
  const { t } = useTranslation();
  const rawSessionStorageItem = sessionStorage.getItem(constants.SESS_STORAGE_APPLICATION_KEY);
  const cachedApp =
    rawSessionStorageItem && rawSessionStorageItem !== 'undefined'
      ? JSON.parse(rawSessionStorageItem)
      : null;
  const { data: newApp, isLoading, isError, error } = useGetNextStep(false, !cachedApp);
  const application = cachedApp || newApp;
  sessionStorage.removeItem(constants.SESS_STORAGE_APPLICATION_KEY);
  const { next_action = 'CREATE_APPLICATION' } = application || {};
  const { data: { customer_id = '', provider = '', payment_option = '' } = {} } =
    useGetPaymentInfo();

  if (isLoading) {
    return <Loader message={t('status.loading.financingApplication')} />;
  } else if (payment_option && payment_option.toUpperCase() !== 'GLOBAL') {
    // Redirect to appropriate module if payment_option is not GLOBAL
    if (provider === 'PATIENTFI') {
      navigate({ to: patientfiFinancingPath, search: true });
    } else {
      navigate({ to: allegroFinancingPath, search: true });
    }
  }

  // No application found? -> Show form to create one
  else if (isError || error?.response?.status === 404 || !application?.next_action) {
    return <CreateApplication customer_id={customer_id} />;
  } else if (application?.next_action) {
    switch (next_action) {
      case 'CREATE_APPLICATION':
        return <CreateApplication type="primary" customer_id={customer_id} />;
      default:
        // For now, only CreateApplication is supported in LendFlow
        // Further steps (SELECT_OFFER, etc.) will be added later
        setError(t('status.error.getFinancingApplicationFailed'));
        navigate({ to: errorPath, search: true });
    }
  }

  return <Loader message={t('status.loading.financingApplication')} />;
}
